import { render, staticRenderFns } from "./organization-audit-detail.vue?vue&type=template&id=3b5cebde&scoped=true&"
import script from "./organization-audit-detail.vue?vue&type=script&lang=js&"
export * from "./organization-audit-detail.vue?vue&type=script&lang=js&"
import style0 from "./organization-audit-detail.vue?vue&type=style&index=0&id=3b5cebde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5cebde",
  null
  
)

export default component.exports